import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Httpservice } from '../httpservice/httpservice';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { FormControl,FormGroup, Validators } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-paiement',
  imports: [ReactiveFormsModule],
  templateUrl: './paiement.html',
  styleUrl: './paiement.css',
})
export class Paiement implements OnInit {
  validerButton="valider"
  load=false;
  loading = true;
  service=true;
  choosen_service=""
  montant:number=0;
  token=""
  payform=new FormGroup({
    nom:new FormControl('',Validators.required),
    telephone:new FormControl('',[Validators.required,Validators.minLength(9),Validators.maxLength(9)]),
    otp:new FormControl('')
  })

  constructor(
    private httpService:Httpservice,
    private activatedRoute:ActivatedRoute,
    private route:Router,
    private cdr: ChangeDetectorRef
  ){

  }
  ngOnInit(): void {
    this.token=this.activatedRoute.snapshot.paramMap.get('token')??""
    if(this.token==""){
      this.route.navigate(['/notfound'])
    }
    this.loading =true;
     this.cdr.detectChanges();

    this.httpService.checkToken(this.token).subscribe({
    next: (rep) => {
      if (rep.code === 200) {
        this.montant = rep.montant;
      } else {
        this.route.navigate(['/notfound']);
      }
    },
    error: (error) => {
      this.route.navigate(['/notfound']);
    },
    complete: () => {
      this.loading = false;
      this.cdr.detectChanges(); // Force update after completion
      console.log('Final loading state:', this.loading);
    }
  });
  }
  retour(){
    this.service=true;
  }
  chooseService(code:string){
    this.choosen_service=code;
    this.service=false;
  }
  getMontant(){
    return this.montant;
  }
  validerPaiement(){
    if(this.choosen_service=='snom' && (this.payform.value.otp=="" || this.payform.value.otp?.length!=6)){
      alert('veuillez remplir le champ otp')
      return;
    }
    let payload={
      token:this.token,
      code_service:this.choosen_service,
      nom:this.payform.value.nom,
      telephone:this.payform.value.telephone,
      otp:this.payform.value.otp??"123456",
      indicatif:"+221"
    }
    this.load=true;
    this.validerButton="Loading..."
    this.httpService.initPayment(payload).subscribe(rep=>{
      console.log(rep)
      this.load=false;
      this.validerButton="valider"

      if(rep.code==200){
        if(this.choosen_service=="snwave" && rep.status=="PENDING"){
          window.location.replace(rep.payment_link)
        }
        if(rep.status=="SUCCESS"){
          alert("Paiement reussi")
          this.payform.reset()
        }
        if(rep.status=="FAILED"){
          alert("Echec de votre paiement")
        }
      }
    },(error)=>{
      this.load=false;
      this.validerButton="valider"
      alert("Une erreur est survenue lors de l'initialisation du paiement.")
    })
  }

}
